import { Box } from "@mui/system";
import BudgetControlTabs from "./BudgetControlMobileContent/BudgetControlTabs";

const BudgetControl = () => {
  return (
    <>
      <Box sx={{ px: 2, pt:1 }}>
        <BudgetControlTabs />
      </Box>
    </>
  );
};

export default BudgetControl;
